import { createAsyncThunk } from "@reduxjs/toolkit";
import { EVENTS } from "../../utils/constants/APIURL.constants";
import AppService from "../../services/AppService";
import { Constants } from "../../utils/constants/Constants";
import { getQueryUrl } from "../../helpers/authhelper";

export const deleteParticipantById = createAsyncThunk(
  "admin/deleteParticipantById",
  async (obj, { rejectWithValue }) => {
    const url = EVENTS.EVENT_REMOVE_PARTICIPANT;
    try {
      const data = await AppService.postCall(obj, url);
      return { data, id: obj?.remove_invites };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const searchParticipant = createAsyncThunk(
  "admin/searchParticipant",
  async (obj, { rejectWithValue }) => {
    let url;
    url = `${EVENTS.EVENT_SEARCH_PARTICIPANT}${obj.event_id}/?${getQueryUrl(
      obj
    )}`;

    try {
      const data = await AppService.getCall(url);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
